@if (isAllergens() || article?.info?.de || isAddit() || isHaveAnyValueMoreZero(article)) {
	<div [class.activated]="this.isMenuOpen" class="container">
		<div (click)="toggleAccordion()" class="header">
			<h2 class="title">{{ 'custom_translation.allergens_title' | translate }}</h2>
			<div class="icon_wrapper">
				<ion-icon [class.isOpen]="isMenuOpen" src="/assets/topgolf/arrow-right.svg"></ion-icon>
			</div>
		</div>
		<div [ngClass]="this.isMenuOpen ? 'active' : 'inactive'">
			@if (article?.info?.de) {
				<div class="container container_allergens_info">
					<h2 class="name">{{ 'common.info' | translate }}</h2>
					<p [innerHtml]="article?.info | langObservable | async"></p>
				</div>
			}
			@if (isAllergens()) {
				<div class="border-top">
					@if (isAllergens()) {
						<h3 class="name">{{ 'allergenes.allergenes' | translate }} *</h3>
					}
					@if (article.compound?.allergens; as item) {
						<ul>
							@if (article.compound?.allergens?.cerealsContainingGluten) {
								<li>
									{{ 'allergenes.cerealsWithGluten' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.crustaceansAndProductsThereof) {
								<li>
									{{ 'allergenes.crustaceans' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.eggsAndProductsThereof) {
								<li>
									{{ 'allergenes.eggs' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.fishAndProductsThereof) {
								<li>
									{{ 'allergenes.fish' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.peanutsAndProductsThereof) {
								<li>
									{{ 'allergenes.peanuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.soyaAndProductsThereof) {
								<li>
									{{ 'allergenes.soya' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.milkAndProductsThereof) {
								<li>
									{{ 'allergenes.milk' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.nuts) {
								<li>
									{{ 'allergenes.nuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.celeryAndProductsThereof) {
								<li>
									{{ 'allergenes.celery' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.mustardAndProductsThereof) {
								<li>
									{{ 'allergenes.mustard' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.sesameSeedsAndProductsThereof) {
								<li>
									{{ 'allergenes.sesame' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.sulfurDioxideAndSulphites) {
								<li>
									{{ 'allergenes.sulfur' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.lupinsAndProductsThereof) {
								<li>
									{{ 'allergenes.lupins' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.molluscsAndProductsThereof) {
								<li>
									{{ 'allergenes.molluscs' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.corn) {
								<li>
									{{ 'allergenes.corn' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.wheat) {
								<li>
									{{ 'allergenes.wheat' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.rye) {
								<li>
									{{ 'allergenes.rye' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.barley) {
								<li>
									{{ 'allergenes.barley' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.oats) {
								<li>
									{{ 'allergenes.oats' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.spelt) {
								<li>
									{{ 'allergenes.spelt' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.khorasan) {
								<li>
									{{ 'allergenes.khorasan' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.walnuts) {
								<li>
									{{ 'allergenes.walnuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.pecanNuts) {
								<li>
									{{ 'allergenes.pecanNuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.brazilNuts) {
								<li>
									{{ 'allergenes.brazilNuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.pistachioNuts) {
								<li>
									{{ 'allergenes.pistachioNuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.macadamiaNuts) {
								<li>
									{{ 'allergenes.macadamiaNuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.almonds) {
								<li>
									{{ 'allergenes.almonds' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.hazelnuts) {
								<li>
									{{ 'allergenes.hazelnuts' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.cashews) {
								<li>
									{{ 'allergenes.cashews' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.seeds) {
								<li>
									{{ 'allergenes.seeds' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.poppySeeds) {
								<li>
									{{ 'allergenes.poppySeeds' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.sunflowerSeeds) {
								<li>
									{{ 'allergenes.sunflowerSeeds' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.poultryMeat) {
								<li>
									{{ 'allergenes.poultryMeat' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.beef) {
								<li>
									{{ 'allergenes.beef' | translate }}
								</li>
							}
							@if (article.compound?.allergens?.pigmeat) {
								<li>
									{{ 'allergenes.pigmeat' | translate }}
								</li>
							}
						</ul>
					}
					<div class="padding-top"></div>
				</div>
			}
			@if (isAddit()) {
				<div class="border-top">
					@if (isAddit()) {
						<h3 class="name">{{ 'additives.additives' | translate }} *</h3>
					}
					@if (article?.compound?.additives) {
						<ul>
							@if (article?.compound?.additives?.blackened) {
								<li>
									{{ 'additives.6' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.caffeinated) {
								<li>
									{{ 'additives.9' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.quinine) {
								<li>
									{{ 'additives.10' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.sulfured) {
								<li>
									{{ 'additives.5' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.waxed) {
								<li>
									{{ 'additives.12' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.withAntioxidant) {
								<li>
									{{ 'additives.3' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.withDye) {
								<li>
									{{ 'additives.1' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.withFlavorEnhancer) {
								<li>
									{{ 'additives.4' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.withMilkProtein) {
								<li>
									{{ 'additives.8' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.withPhosphate) {
								<li>
									{{ 'additives.7' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.withPreservative) {
								<li>
									{{ 'additives.2' | translate }}
								</li>
							}
							@if (article?.compound?.additives?.withSweetener) {
								<li>
									{{ 'additives.11' | translate }}
								</li>
							}
						</ul>
					}
					<div class="padding-top"></div>
				</div>
			}
			@if (isHaveAnyValueMoreZero(article)) {
				<div class="container border-top">
					<h2 class="name">{{ 'accordion_list.nutrition_100g' | translate }}</h2>
					@if (article?.nutritions?.energyKcalPer100g || article?.nutritions?.energyKcalPer100g) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.energyKjPerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								{{ numberD(article?.nutritions?.energyKcalPer100g) }}
								{{ 'nutrition.energyKjPerPortionSize' | translate }}
							</ion-col>
						</ion-row>
					}
					@if (article?.nutritions?.energyKcalPerPortion || article?.nutritions?.energyKcalPer100g) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.energyKcalPerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								{{ numberD(article?.nutritions?.energyKcalPer100g) }}
								{{ 'nutrition.energyKcalPerPortionSize' | translate }} /
								{{ numberD(article?.nutritions?.energyKcalPerPortion) }}
								{{ 'nutrition.energyKcalPerPortionSize' | translate }}
							</ion-col>
						</ion-row>
					}
					@if (article?.nutritions?.fatPerPortion || article?.nutritions?.fatPer100g) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.fatPerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								{{ numberD(article?.nutritions?.fatPer100g) }}
								{{ 'nutrition.fatPerPortionSize' | translate }} /
								{{ numberD(article?.nutritions?.fatPerPortion) }}
								{{ 'nutrition.fatPerPortionSize' | translate }}
							</ion-col>
						</ion-row>
					}
					@if (article?.nutritions?.saturatesPerPortion || article?.nutritions?.saturatesPer100g) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.saturatesPerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								{{ numberD(article?.nutritions?.saturatesPer100g) }}
								{{ 'nutrition.portionInGSize' | translate }} /
								{{ numberD(article?.nutritions?.saturatesPerPortion) }}
								{{ 'nutrition.portionInGSize' | translate }}
							</ion-col>
						</ion-row>
					}
					@if (article?.nutritions?.carbohydratePerPortion || article?.nutritions?.carbohydratePer100g) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.carbohydratePerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								{{ numberD(article?.nutritions?.carbohydratePer100g) }}
								{{ 'nutrition.sugarPerPortionSize' | translate }} /
								{{ numberD(article?.nutritions?.carbohydratePerPortion) }}
								{{ 'nutrition.sugarPerPortionSize' | translate }}
							</ion-col>
						</ion-row>
					}
					@if (article?.nutritions?.sugarPerPortion || article?.nutritions?.sugarPer100g) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.sugarPerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								{{ numberD(article?.nutritions?.sugarPer100g) }}
								{{ 'nutrition.sugarPerPortionSize' | translate }} /
								{{ numberD(article?.nutritions?.sugarPerPortion) }}
								{{ 'nutrition.sugarPerPortionSize' | translate }}
							</ion-col>
						</ion-row>
					}
					@if (article?.nutritions?.proteinPer100g || article?.nutritions?.proteinPerPortion) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.proteinPerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								{{ numberD(article?.nutritions?.proteinPer100g) }}
								{{ 'nutrition.sugarPerPortionSize' | translate }} /
								{{ numberD(article?.nutritions?.proteinPerPortion) }}
								{{ 'nutrition.sugarPerPortionSize' | translate }}
							</ion-col>
						</ion-row>
					}
					@if (article?.nutritions?.saltPerPortion || article?.nutritions?.saltPer100g) {
						<ion-row>
							<ion-col class="nutrition-name" class="nutrition-name" size="6"
								>{{ 'nutrition.saltPerPortion' | translate }}
							</ion-col>
							<ion-col class="nutrition-value" size="6">
								<{{ numberD(article?.nutritions?.saltPer100g) }} {{ 'nutrition.sugarPerPortionSize' | translate }} / <{{
									numberD(article?.nutritions?.saltPerPortion)
								}}
								{{ 'nutrition.sugarPerPortionSize' | translate }}
							</ion-col>
						</ion-row>
					}
				</div>
			}
			<div class="final_text">
				<p class="name">{{ 'allergens_external_info' | translate }}</p>
			</div>
		</div>
		<ion-row class="padding-block">
			<div class="separator"></div>
		</ion-row>
	</div>
}
